import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex } from 'components/styled/Flex';

import { HeaderTitle } from './Header.styled';

interface IHeader {
  title: string;
  children?: ReactNode;
}

export const Header = ({ title, children }: IHeader) => {
  const { t } = useTranslation();

  return (
    <Flex alignItems="center" justifyContent="space-between" flexWrap="wrap">
      <HeaderTitle>{t(title)}</HeaderTitle>
      {children}
    </Flex>
  );
};
